import {Component, Input, OnInit} from '@angular/core';
import {Information} from '../../../interfaces/spot.interface';
import {Language} from '../../../interfaces/language';
import {NgForOf, NgIf} from '@angular/common';
import {IonText} from '@ionic/angular/standalone';

@Component({
  selector: 'app-spot-information',
  templateUrl: './spot-information.component.html',
  styleUrls: ['./spot-information.component.scss'],
  imports: [
    NgIf,
    NgForOf,
    IonText
  ]
})
export class SpotInformationComponent implements OnInit {
  @Input() locationState!: Information | any;
  @Input() useLang: Language = 'ja';
  @Input() type!: 'spot' | 'area';

  currentMainImageState!: Information;
  subImageStates: Information[] = [];
  noImagePath = 'assets/images/noImage.jpg';

  constructor() {
  }

  ngOnInit() {

    this.locationState = {
      ...this.locationState
    };

    // 初期値としてlocationStateを設定
    this.currentMainImageState = this.locationState;

    // サブ画像の初期値を設定
    this.subImageStates = this.locationState.subThumbnails?.map((imgUrl: string) => {
      return {...this.locationState, locationImgUrl: imgUrl};
    });

  }

  /*
  サブ画像をクリックした時の処理
  メイン画像とサブ画像入れ替え
  */
  public changeMainImage(clickedSubImageState: Information): void {
    console.log(clickedSubImageState);
    const index = this.subImageStates.indexOf(clickedSubImageState);
    if (index !== -1) {
      // クリックされたサブ画像をサブ画像のリストから削除
      this.subImageStates.splice(index, 1);

      // 現在のメイン画像をサブ画像のリストに追加
      this.subImageStates.push(this.currentMainImageState);

      // クリックされたサブ画像をメイン画像に設定
      this.currentMainImageState = clickedSubImageState;
    }
  }

  /**
   * 対象言語のデータあるか
   */
  get hasTargetLangAddress(): boolean {
    return this.useLang === 'ja' ||
      !this.useLang ||
      !this.locationState.translation ||
      !this.locationState.translation[this.useLang] ||
      this.locationState.translation[this.useLang]?.address == null;
  }

  /**
   * 対象言語のデータあるか
   */
  get hasTargetLangDetail(): boolean {
    return this.useLang === 'ja' ||
      !this.useLang ||
      !this.locationState.translation ||
      !this.locationState.translation[this.useLang] ||
      this.locationState.translation[this.useLang]?.detail == null;
  }
}
